import { useLanguage } from "@ihs-widget/utils/hooks/useLanguage";
import { useTranslations } from "../../../../../../translation/TranslationContext";

const TableHeader = () => {
    const language = useLanguage();
    const t = useTranslations(language);

    return (
        <div data-testid="h2h-table-header" className='flex flex-row justify-start items-center 
                        w-full
                        sm351:w-[319px]
                        text-[12px] font-normal leading-[16px] font-robotoRegular
                        text-monoX dark:text-monoY h-[16px] gap-[4px]'>
            <div data-testid="h2h-table-header-place-shortcut" className='flex justify-center items-center 
                            ml-[calc(30%+8px)] w-[22px]
                            sm351:ml-[127px] 
                            sm320:ml-[calc(36%+8px)] 
                            sm300:ml-[calc(30%+4px)] 
                            '>{t[`InHouseStats.H2HPlaceShortcut`]}</div>
            <div data-testid="h2h-table-header-plus-minus" className='flex justify-center items-center sm351:w-[44px] w-[44px]'>{t[`InHouseStats.H2HPlusMinus`]}</div>
            <div data-testid="h2h-table-header-points" className='flex justify-center items-center sm351:w-[22px] w-[22px]'>{t[`InHouseStats.H2HPoints`]}</div>
            <div data-testid="h2h-table-header-form" className='flex justify-center items-center sm351:w-[88px] w-[88px] ml-[4px]'>{t[`InHouseStats.H2HForm`]}</div>
        </div>
    )
}

export default TableHeader;